'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useId, useSyncExternalStore } from 'react';
import { useFaqIsSearching, useFaqSearchStore } from './FaqSearchContext';
import FaqSearchResults from './FaqSearchResults';
export default function FaqGroupSectionWrapper(t0) {
  const $ = _c(19);
  const {
    children
  } = t0;
  const isSearching = useFaqIsSearching();
  const store = useFaqSearchStore();
  const ownerId = useId();
  let t1;
  if ($[0] !== store?.subscribe) {
    t1 = store?.subscribe ?? _temp2;
    $[0] = store?.subscribe;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ownerId || $[3] !== store) {
    t2 = () => store?.getResultsOwner() === ownerId;
    $[2] = ownerId;
    $[3] = store;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isOwner = useSyncExternalStore(t1, t2, _temp3);
  let t3;
  if ($[5] !== isSearching || $[6] !== ownerId || $[7] !== store) {
    t3 = () => {
      if (!store) {
        return;
      }
      if (isSearching) {
        store.claimResultsOwner(ownerId);
        return () => store.releaseResultsOwner(ownerId);
      }
      store.releaseResultsOwner(ownerId);
    };
    $[5] = isSearching;
    $[6] = ownerId;
    $[7] = store;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isSearching || $[10] !== store) {
    t4 = [isSearching, store];
    $[9] = isSearching;
    $[10] = store;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  if (!isSearching) {
    let t5;
    if ($[12] !== children) {
      t5 = <>{children}</>;
      $[12] = children;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  if (isOwner) {
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <FaqSearchResults />;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== children) {
      t6 = <>{t5}<div className="hidden">{children}</div></>;
      $[15] = children;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t5;
  if ($[17] !== children) {
    t5 = <div className="hidden">{children}</div>;
    $[17] = children;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp3() {
  return false;
}
function _temp2() {
  return _temp;
}
function _temp() {}